// 将树形结构转换成单层的数组结构
import el from "element-ui/src/locale/lang/el";
import Store from "../vuex/store";
import Row from "../base/one_row";
import Col from "../base/one_column";

export const treeJsonToArray = (nodes) => {
  nodes = JSON.parse(JSON.stringify(nodes))
  let r = []
  if (Array.isArray(nodes)) {
    for (let i = 0, l = nodes.length; i < l; i++) {
      r.push(nodes[i]) // 取每项数据放入一个新数组
      if (Array.isArray(nodes[i]["children"]) && nodes[i]["children"].length > 0) {
        // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
        r = r.concat(treeJsonToArray(nodes[i]["children"]))
        delete nodes[i]["children"]
      }
    }
  }
  return r
}

// 元素相对与窗口顶部位置
export const getTopByWindow = (e) => {
  let offset = e.offsetTop
  if (e.offsetParent != null) {
    offset += getTopByWindow(e.offsetParent)
  }
  return offset
}

// 元素相对与窗口左边位置
export const getLeftByWindow = (e) => {
  let offset = e.offsetLeft
  if (e.offsetParent != null) {
    offset += getLeftByWindow(e.offsetParent)
  }
  return offset
}

/*
 * 时间戳转时间
 * timestamp: 时间戳
 * format0: YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss
 * format1: YYYY-MM-DD hh:mm:ss
 */
export const timeConvert = (timestamp, format) => {
  timestamp = timestamp + '';
  timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
  var date = new Date(Number(timestamp))
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  if (format == 0) {
    return y + '-' + m + '-' + d;
  } else {
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  }
}

export const fixTagNesting = (str = '') => {
  let el = document.createElement('div')
  el.innerHTML = str
  return el.innerHTML
}

export const createEmptyTemplate = (scheme = [], isNewRow = true) => {
  // scheme = [[[[[1]], [[1]], [[1]]]], [], []]
  // scheme = [[[1, 1]], [[1, 1]], [[1, 1]]]
  Store.commit('app/ADD_widgets_id');
  const row = new Row({
    name: 'layout_row',
    widgets_id: Store.state.app.widgets_id,
    rowType: 'body',
    isNewRow: true,
    newType: 'row1',
    children: []
  });
  row.data = row.data || {}
  row.data.pc_widgets_infor = {}
  scheme.forEach((col_1, index) => {
    //生成一个col
    Store.commit('app/ADD_widgets_id');

    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType: 'body',
      pid: row.widgets_id,
      isNewCol: Array.isArray(col_1), //true,
      newType: 'col1',
      children: []
    });
    col.data.mb_infor.order = index
    row.children.push(col);
    row.data.col_order_array.push(col.data.col_id);
    col.data.pc_infor.col = getColNum(scheme);

    (col_1 || []).forEach(row_2 => {
      Store.commit('app/ADD_widgets_id');
      const row2Instance = new Row({
        name: 'layout_row',
        widgets_id: Store.state.app.widgets_id,
        pid: col.widgets_id,
        rowType: 'body',
        isNewRow: true,
        newType: 'row2',
        children: []
      });
      row2Instance.name = 'layout_row_2'
      row2Instance.data = row2Instance.data || {}
      row2Instance.data.pc_widgets_infor = {}
      col.children.push(row2Instance);

      (row_2 || []).forEach((col_2, i) => {
        Store.commit('app/ADD_widgets_id');
        const col2Instance = new Col({
          widgets_id: Store.state.app.widgets_id,
          rowType: 'body',
          pid: col.widgets_id,
          isNewCol: true,
          newType: 'col2',
          children: []
        });
        col2Instance.data.mb_infor.order= i
        col2Instance.data.pc_infor.col = getColNum(row_2)
        row2Instance.children.push(col2Instance)
        row2Instance.data.col_order_array.push(col2Instance.data.col_id)
      });
    })
  })

  return row
}

function getColNum(cols) {
  let len = cols.length
  if (len === 1) {
    return 12
  } else if (len === 2) {
    return 6
  } else if (len === 3) {
    return 4
  } else if (len === 4) {
    return 3
  }
}


// 有很多地方默认样式是写在css里的（主要是因为不同的模块样式有不同的默认值），所以获取样式的函数默认不返回默认值
export const getFontStyle = (fontInfo, option = {needDefault: false}) => {
  let fontStyle = {}
  let font = fontInfo[fontInfo.radio_val]
  if (!option.needDefault && fontInfo.radio_val === 'default') {
    return {}
  }
  if (fontInfo.radio_val === 'hidden') {
    return {
      display: 'none'
    }
  }
  fontStyle.fontSize = font.fontSize + 'px'
  fontStyle.fontFamily = font.fontFamily
  fontStyle.fontWeight = font.fontWeight
  fontStyle.fontStyle = font.fontItalics
  fontStyle.textDecoration = font.fontUnderline

  if (font.pattern == 'linear_gradient') {
    fontStyle.webkitBackgroundClip = 'text'
    fontStyle.webkitTextFillColor = 'transparent'
    fontStyle.color = ''
    fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
      font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
      '%)'
  } else {
    fontStyle.color = font.fontColor
  }
  return fontStyle
}


export const getSelectFontStyle = (fontInfo, option = {needDefault: false}) => {
  let fontStyle = {}
  let font = fontInfo[fontInfo.radio_val]
  if (!option.needDefault && fontInfo.radio_val === 'default') {
    return {}
  }
  if (fontInfo.radio_val === 'hidden') {
    return {
      display: 'none'
    }
  }
  fontStyle.fontSize = font.fontSize + 'px'
  fontStyle.fontFamily = font.fontFamily
  fontStyle.fontWeight = font.fontWeight
  fontStyle.fontStyle = font.fontItalics
  fontStyle.textDecoration = font.fontUnderline

  if (font.pattern == 'linear_gradient') {
    fontStyle.webkitBackgroundClip = 'text'
    fontStyle.webkitTextFillColor = 'transparent'
    fontStyle.color = ''
    fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
      font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
      '%)'
  } else {
    fontStyle.color = font.fontSeColor
  }
  return fontStyle
}

export const getBackgroundStyle = (infor, option = {needDefault: false}) => {
  if (!option.needDefault && infor.radio_val === 'default') {
    return {}
  }
  if (infor.radio_val === 'hidden') {
    return {
      background: 'none'
    }
  }
  return {
    backgroundColor: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.color : (option.defaultBackgroundColor || ''),
    backgroundImage: infor.set_style.background.radio_val == 'custom' && infor.set_style.background.custom.img !== '' ? 'url(' + infor.set_style.background.custom.img + ')' : '',
    backgroundSize: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_size : '',
    backgroundRepeat: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_repeat : '',
    backgroundPosition: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_position : ''
  }
}

// 上面那个不好
export const getBackground = (background, option = {needDefault: false}) => {
  if(!background){
    return {}
  }
  if (!option.needDefault && background.radio_val === 'default') {
    return {}
  }
  if (background.radio_val === 'hidden') {
    return {
      background: 'none'
    }
  }
  return {
    backgroundColor: background[background.radio_val].color,
    backgroundImage: `url(${background[background.radio_val].img})`,
    backgroundSize: background[background.radio_val].background_size,
    backgroundRepeat: background[background.radio_val].background_repeat,
    backgroundPosition: background[background.radio_val].background_position
  }
}

export const getSelectBackground = (background, option = {needDefault: false}) => {
  if (!option.needDefault && background.radio_val === 'default') {
    return {}
  }
  if (background.radio_val === 'hidden') {
    return {
      background: 'none'
    }
  }
  return {
    backgroundColor: background[background.radio_val].seColor,
  }
}

export const getBoxShadowStyle = (boxShadow, type = 'default') => {
  let data = boxShadow[boxShadow.radio_val]
  let str = `${data.x}px ${data.y}px ${data.blur}px ${data.spread}px ${type === 'default' ? data.color : data.seColor}`
  if (data.direction === 'inset') {
    str = 'inset ' + str
  }
  return {
    boxShadow: str
  }
}


export const getBorderStyle = (border, option = {needDefault: false}) => {
  if (!option.needDefault && border.radio_val === 'default') {
    return {}
  }
  if (border.radio_val === 'hidden') {
    return {
      border: 'none'
    }
  }
  return {
    borderColor: border.radio_val !== 'hidden' ? border[border.radio_val].border_color : 'transparent',
    borderStyle: border.radio_val !== 'hidden' ? (border[border.radio_val].border_style || 'solid') : 'none',
    borderLeftWidth: border.radio_val !== 'hidden' ? border[border.radio_val].border_left_width + 'px' : 0,
    borderRightWidth: border.radio_val !== 'hidden' ? border[border.radio_val].border_right_width + 'px' : 0,
    borderTopWidth: border.radio_val !== 'hidden' ? border[border.radio_val].border_top_width + 'px' : 0,
    borderBottomWidth: border.radio_val !== 'hidden' ? border[border.radio_val].border_bottom_width + 'px' : 0,
  }
}

export const getBorderRadiusStyle = (borderRadius, option = {needDefault: false}) => {
  if (!option.needDefault && borderRadius.radio_val === 'default') {
    return {}
  }
  return {
    borderRadius: borderRadius[borderRadius.radio_val].value + 'px'
  }
}

export const getMarginStyle = (margin, option = {needDefault: false}) => {
  if (!option.needDefault && margin.radio_val === 'default') {
    return {}
  }
  let data = margin[margin.radio_val]
  return {
    marginTop: data.marginTop + 'px',
    marginBottom: data.marginTop + 'px',
    marginLeft: data.marginLeft + 'px',
    marginRight: data.marginLeft + 'px',
  }
}

export const getHalfMarginStyle = (margin, option = {needDefault: false}) => {
  if (!option.needDefault && margin.radio_val === 'default') {
    return {}
  }
  let data = margin[margin.radio_val]
  return {
    marginTop: data.marginTop / 2 + 'px',
    marginBottom: data.marginTop / 2 + 'px',
    marginLeft: data.marginLeft / 2 + 'px',
    marginRight: data.marginLeft / 2 + 'px',
  }
}

export const insertStyle = (font = {}) => {
  if (Array.isArray(font)) {
    font.forEach(f => {
      _insertStyle(f)
    })
  } else {
    _insertStyle(font)
  }

  function _insertStyle(font = {}) {
    let style = `<style type="text/css" id="${font.name}" >
            @font-face {
                font-family: '${font.name}';
                src: url('${font.url}') format('truetype');
                font-weight: normal;
                font-style: normal;
            }
        </style>`
    $(document.head).append(style)
  }

}

export const getFontFamily = (info) => {
  let customFont = info.customFont
  if (customFont.name) {
    return customFont.name
  } else {
    return info.fontFamily
  }
}

export const flatTree = (data, treeMap = [], depth = 0) => {
  if (!(data && data.length)) return;
  depth++;
  return data.reduce((acc, cur) => {
    cur.depth = depth;
    acc.push(cur);
    if (cur.children && cur.children.length) {
      this.flatTree(cur.children, treeMap, depth);
    }
    return acc;
  }, treeMap);
}

export const getMbInforFromPCInfor = (pc_widgets_infor) => {
  let {moduleStyle, tagLayout, ...mb_widgets_infor} = pc_widgets_infor
  mb_widgets_infor = JSON.parse(JSON.stringify(mb_widgets_infor))
  for (let k in mb_widgets_infor) {
    delete mb_widgets_infor[k].default
  }
  return mb_widgets_infor
}
export const closeHTML =(str)=> {
  var arrTags=["span","font","b","u","i","h1","h2","h3","h4","h5","h6","p","li","ul","table","div"];
  for(var i=0;i<arrTags.length;i++){
  var intOpen=0;
  var intClose=0;
  var re=new RegExp("\\<"+arrTags[i]+"( [^\\<\\>]+|)\\>","ig");
  var arrMatch=str.match(re);
  if(arrMatch!=null) intOpen=arrMatch.length;
  re=new RegExp("\\<\\/"+arrTags[i]+"\\>","ig");
  arrMatch=str.match(re);
  if(arrMatch!=null) intClose=arrMatch.length;
  for(var j=0;j<intOpen-intClose;j++){
  str+="</"+arrTags[i]+">";
  }
  }
  return str;
}
  /**
   * This is just a simple version of deep copy
   * Has a lot of edge cases bug
   * If you want to use a perfect deep copy, use lodash's _.cloneDeep
   * @param {Object} source
   * @returns {Object}
   */
  export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function getStr(str) {
  if (typeof str == 'string') {
    try {
      return JSON.parse(str)
    } catch (e) {
      return {}
    }
  }
  return str
}

export const getStyle = (obj, attr) => {
  if (!obj) return
  return obj.currentStyle ? obj.currentStyle[attr || 'width'] : getComputedStyle(obj, false)[attr || 'width'];
}


// WEBPACK FOOTER //
// ./src/utils/utils.js